module.exports = __webpack_public_path__ + "1c7eba1a5d56acdb20a431eefc890294.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/text.png
// module id = 157
// module chunks = 0